import type { FunctionComponent } from "react";

interface IconXProps {
  color?: string;
}

const IconX: FunctionComponent<IconXProps> = ({ color = "#000000" }) => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1757 0H16.9357L10.9058 7.27684L18 17.177H12.4455L8.0955 11.1718L3.117 17.177H0.3555L6.8055 9.39338L0 0.000791858H5.6955L9.62775 5.4897L14.1757 0ZM13.2075 15.4334H14.7367L4.8645 1.65253H3.2235L13.2075 15.4334Z"
        fill={color}
      />
    </svg>
  );
};

export default IconX;
